import { Link } from "react-router-dom";
import { services as defaultServices } from "@/data/services";
import { serviceValueToRoute, serviceLandingData } from "@/data/serviceLandingData";
import { Home, Paintbrush, Wrench, Box, Droplet, Layers, Brush, Settings, Hammer } from "lucide-react";

const iconMap = { Home, Paintbrush, Wrench, Box, Droplet, Layers, Brush, Settings };
const iconList = [Home, Layers, Wrench, Box, Droplet, Brush, Paintbrush, Settings];

// Fallback: CMS-Services haben teils kein `value` — Route über Titel auflösen
const titleToRoute = Object.fromEntries(
  serviceLandingData.map((s) => [s.formService, s.canonicalPath])
);

const Services = ({ content }) => {
  let serviceList = content?.services
    ? content.services.filter(s => s.active !== false).map((s, i) => ({
        ...s,
        icon: iconList[i % iconList.length]
      }))
    : defaultServices;

  // Verputzer-Kachel ergänzen, falls CMS-Content sie (noch) nicht kennt
  if (content?.services && !content.services.some(s => (s.title || "").includes("Verputzer"))) {
    const verputzer = defaultServices.find(s => s.value === "verputzer");
    if (verputzer) serviceList = [...serviceList, { ...verputzer, icon: Hammer }];
  }
  return (
    <section className="py-16 sm:py-20 bg-white" id="leistungen" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#4A331D] mb-3"
            style={{ fontFamily: "Work Sans, sans-serif" }}
          >
            Unsere Leistungen
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Professionelle Bauleistungen aus einer Hand
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {serviceList.map((service, index) => {
            const Icon = service.icon;
            const route = serviceValueToRoute[service.value] || titleToRoute[service.title];
            const cardInner = (
              <>
                <div className="w-12 h-12 bg-[#4A331D] rounded-lg flex items-center justify-center mx-auto mb-3">
                  <Icon className="w-6 h-6 text-[#D4AA6A]" />
                </div>
                <h3 className="text-base font-semibold text-[#4A331D] mb-1.5">
                  {service.title}
                </h3>
                <p className="text-xs text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </>
            );
            const cardClass = "bg-[#faf8f5] border border-[#e8dfd4] p-5 rounded-xl hover:border-[#D4AA6A] hover:shadow-md transition-all duration-300 text-center";
            return route ? (
              <Link
                key={index}
                to={route}
                className={`${cardClass} block`}
                data-testid={`service-card-${index}`}
                aria-label={`Mehr über ${service.title}`}
              >
                {cardInner}
              </Link>
            ) : (
              <div key={index} className={cardClass} data-testid={`service-card-${index}`}>
                {cardInner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
